import { DefaultRenderPathResolver } from '../DefaultRenderPathResolver.js';
import { DicomMicroscopyPath } from './DicomMicroscopyRenderPath.js';
export function createDefaultWSIRenderPaths() {
    return [new DicomMicroscopyPath()];
}
export function createWSIRenderPathResolver(paths = createDefaultWSIRenderPaths()) {
    return new DefaultRenderPathResolver(paths);
}
